import React from 'react';
import { SanityBody } from '@shared/components';
import { Chip, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useChangelogTFunction } from '@retail/changelog/i18n';
import { ChangelogEntry as ChangelogEntryType } from '@retail/changelog/types';
import { ChangelogTags } from './ChangelogTags';

type Props = ChangelogEntryType;

export const ChangelogEntry: React.FC<Props> = ({ title, content, changeDate, tags, seen }) => {
  const t = useChangelogTFunction();

  return (
    <Stack direction="row" spacing={1} justifyContent="space-between" paddingX={3} py={2}>
      <Stack spacing={1} width="160px" alignItems="start" pt={0.5}>
        {/*@ts-ignore*/}
        <Typography variant="body2">{dayjs(changeDate).fromNow()}</Typography>
        {!seen && (
          <Chip
            label={t('changelog.recentChanges.new')}
            sx={(theme) => ({
              backgroundColor: 'secondary.light',
              ...theme.applyStyles('dark', { color: 'background.default' }),
            })}
            size="small"
          />
        )}
        <ChangelogTags tags={tags} />
      </Stack>
      <Stack spacing={2} width="500px">
        <Typography variant="h4" component="h2">
          {title}
        </Typography>
        <SanityBody body={content} />
      </Stack>
    </Stack>
  );
};
